import { IconCallout } from 'components/IconCallout';
import Swatch from 'components/Swatch';
import IconTruck from 'components/IconTruck';
import IconHanger from 'components/IconHanger';
import IconJacket from 'components/IconJacket';
import { Product } from 'types';

type IconCalloutGridProps = {
  showIconShipping: boolean;
  showIconSwatches: boolean;
  showIconHTO: boolean;
  showIconGroomsFree: boolean;
  swatchesCalloutUrl?: string;
  htoCalloutUrl?: string;
  swatch?: Product;
} & ClassNameProp;

const IconCalloutGrid = ({
  showIconShipping,
  showIconSwatches,
  showIconHTO,
  showIconGroomsFree,
  swatchesCalloutUrl,
  htoCalloutUrl,
  className,
  swatch,
}: IconCalloutGridProps) => {
  const bottomMargin = showIconShipping ? 16 : 32;

  return (
    <>
      <div
        className={`mb-${bottomMargin} mt-8 grid grid-cols-3 gap-16 xs:px-64 sm:px-0 sm-only:grid-cols-2 md-only:gap-8 ${
          className ?? ''
        }`}
      >
        {showIconHTO && (
          <IconCallout
            title="Home Try-on"
            icon={<IconHanger className="self-end" />}
            href={htoCalloutUrl}
            linkText="Get Started"
            trackerClass="tracker-text-product_page-icon_callout_hto-201023-151538"
            className="pt-24 pb-40"
          />
        )}

        {showIconSwatches && (
          <IconCallout
            title="Free Swatches"
            icon={<Swatch className="self-end" swatch={swatch!} swatchSize={44} />}
            linkText="Select Swatches"
            trackerClass="tracker-text-product_page-icon_callout_swatch-201023-151538"
            className="pt-24 pb-40"
            href={swatchesCalloutUrl}
          />
        )}

        {showIconGroomsFree && (
          <IconCallout
            title="Free Rental"
            icon={<IconJacket className="self-end" />}
            href="/groomsfree"
            linkText="See Offer"
            trackerClass="tracker-text-product_page-icon_callout_free_rent-201023-151538"
            className="pt-24 pb-40"
          />
        )}
      </div>

      {showIconShipping && (
        <div className={`mb-32 grid grid-cols-3 gap-16 xs:px-64 sm:px-0 ${className ?? ''}`}>
          <IconCallout
            title="Free Shipping"
            icon={<IconTruck />}
            trackerClass="tracker-text-product_page-icon_callout_ship-201023-151538"
            className="col-span-3 py-12"
            horizontalLayout={true}
          />
        </div>
      )}
    </>
  );
};

export default IconCalloutGrid;
